import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    errorState:'',
    successState:'',
}

const errorReducer = createSlice({
    name: 'error',
    initialState,
    reducers:{
        setErrorMessage: (state,action)=>{
            state.errorState = action.payload;
        },
        setSuccessState: (state,action)=>{
            state.successState = action.payload;
        },
    }
});

export default errorReducer.reducer;

export const {setErrorMessage,setSuccessState} = errorReducer.actions; 